import update from "immutability-helper";
import { UPDATE_EMPLOYEE_PROFILE } from "QuotePage/Actions";
import _ from "underscore";

import {
  ADD_EMPLOYEE,
  ADD_SPOUSE,
  ADD_CHILD,
  REMOVE_CHILD,
  REMOVE_EMPLOYEE,
  REMOVE_SPOUSE,
  UPDATE_EMPLOYEE_AGE,
  UPDATE_SPOUSE_AGE,
  UPDATE_CHILD_AGE,
  UPDATE_OVERALL_ERROR_MESSAGE,
  REPLACE_EMPLOYEE_PROFILE,
} from "./Actions";

export const emptyEmployeeProfile = Object.freeze([
  Object.freeze({
    name: "Employee 1",
    age: null,
    children: [],
  }),
]);
export function employeeProfileReducer(state = emptyEmployeeProfile, action) {
  switch (action.type) {
    case UPDATE_EMPLOYEE_PROFILE:
      return action.employeeProfile;

    case ADD_EMPLOYEE:
      return update(state, {
        $push: [
          {
            name: `Employee ${state.length + 1}`,
            age: null,
            children: [],
          },
        ],
      });

    case REMOVE_EMPLOYEE:
      if (state.length == 1) {
        return emptyEmployeeProfile;
      }
      return update(state, {
        $splice: [[action.index, 1]],
      });

    case ADD_SPOUSE:
      return update(state, {
        [action.index]: {
          $merge: {
            spouse_age: null,
          },
        },
      });

    case REMOVE_SPOUSE:
      return update(state, {
        [action.index]: {
          $unset: ["spouse_age"],
        },
      });

    case UPDATE_EMPLOYEE_AGE:
      return update(state, {
        [action.index]: {
          $merge: {
            age: action.age,
          },
        },
      });

    case UPDATE_SPOUSE_AGE:
      return update(state, {
        [action.index]: {
          $merge: {
            spouse_age: action.age,
          },
        },
      });

    case ADD_CHILD:
      return update(state, {
        [action.index]: {
          children: {
            $push: [null],
          },
        },
      });

    case REMOVE_CHILD:
      return update(state, {
        [action.index]: {
          children: {
            $splice: [[action.childIndex, 1]],
          },
        },
      });

    case UPDATE_CHILD_AGE:
      return update(state, {
        [action.index]: {
          children: {
            $splice: [[action.childIndex, 1, action.age]],
          },
        },
      });

    case REPLACE_EMPLOYEE_PROFILE:
      if (state.length == 0) {
        return emptyEmployeeProfile;
      }
      return action.payload;

    default:
      return state?.length === 0 ? emptyEmployeeProfile : state;
  }
}
export function employeeProfileOverallErrorReducer(state = null, action) {
  if (action.type === UPDATE_OVERALL_ERROR_MESSAGE && typeof action.errorMessage !== "undefined") {
    return action.errorMessage;
  }
  return state;
}
